import React, { Component } from "react";
import {
  alert,
  toFixed,
  format_date,
  GET,
  POST,
  PUT,
  loading,
  Status,
  params,
  DateRangePicker,
  Pagination,
  Navbar,
  Modal,
  Select,
  XLSX,
  saveAs,
  StatusTnx,
} from "../../components/CustomComponent.js";
import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";
export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // MODAL
      modal_create: false,
      modal_update: false,
      modal_detail: false,

      // SEARCH
      filter_status: "",
      filter_start_date: "",
      filter_end_date: "",
      filter_data_search: "",
      filter_process_type: "",
      filter_currency: "THB",

      // EXPORT
      export_date: "",

      // LIST
      data: [],
      loaded: false,
      count: 10,
      data_customer: [],
      data_bank: [],

      // DETAIL
      customer_id: "",
      broker_id: "",

      uid: "",
      type: "",
      ref_no: "",
      status: "",
      amount: "",
      created_at: null,
      cost_gateway: "",
      fee: "",
      fee_rate: "",
      fee_type: "",
      vat: "",
      vat_rate: "",
      vat_type: "",
      is_vat: false,
      is_usdt: false,
      gateway: null,
      amount_net: "",
      open_balance: null,
      close_balance: null,
      currency: "",
      transaction_id: null,
      transfer_date: null,
      remark: null,
      broker: null,
      customer: null,

      bank_code: "",
      bank_account_number: "",
      bank_account_name_th: "",
      bank_account_name_en: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([this.GetMaster(), this.Get(1)]);
  }
  // ตัวเลือกของ dropdown ทั้งหน้า ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
  // ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_customer, data_bank;
    let [result_customer, result_bank] = await Promise.all([
      GET("v1/admin/customers", { page_size: 100000, page: 0, data_search: "" }),
      GET("v1/admin/banks", { page_size: 100000, page: 0, data_search: "" }),
    ]);
    if (result_customer?.status) {
      data_customer = result_customer?.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
        bank_code: e.bank_code,
        bank_account_name_th: e.bank_account_name_th,
        bank_account_name_en: e.bank_account_name_en,
        bank_account_number: e.bank_account_number,
        broker: e.broker?.uid || "",
      }));
    }
    if (result_bank?.status) {
      const popularBankCodes = [
        "SCB",
        "KBANK",
        "KTB",
        "BBL",
        "BAY",
        "TTB",
        "CIMB",
      ];
      data_bank = result_bank.data
        .sort((a, b) => {
          const indexA = popularBankCodes.indexOf(a.code);
          const indexB = popularBankCodes.indexOf(b.code);

          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB; // ถ้าอยู่ทั้งคู่ใน popular → เรียงตามลำดับ
          } else if (indexA !== -1) {
            return -1; // a อยู่ใน popular → ให้มาก่อน
          } else if (indexB !== -1) {
            return 1; // b อยู่ใน popular → ให้มาก่อน
          } else {
            return a.name_en.localeCompare(b.name_en); // ไม่อยู่ใน popular → เรียงตามชื่อ
          }
        })
        .map((e) => ({
          value: e.code,
          label: e.name_en,
          front: (
            <img
              alt="bank"
              src={require(`../../assets/images/bank/${
                global.bank.find((b) => b.value === e.code)?.icon || "bank.png"
              }`)}
              width={18}
              height={18}
              style={{ marginRight: 6 }}
            />
          ),
        }));
    }
    this.setState({ data_customer, data_bank });
  };
  Get = async (page) => {
    const {
      filter_data_search,
      filter_start_date,
      filter_end_date,
      filter_status,
      filter_process_type,
      filter_currency,
    } = this.state;
    let data, count;
    loading(true);
    let [result] = await Promise.all([
        GET(`transactions/${params("type")}/list`, {
          page_size: 10,
          page: page,
          data_search: filter_data_search,
          start_date: filter_start_date
            ? format_date(filter_start_date, "yyyy-mm-dd", "en")
            : "",
          end_date: filter_end_date
            ? format_date(filter_end_date, "yyyy-mm-dd", "en")
            : "",
          filter_status: filter_status,
          process_type: filter_process_type,
          broker_id: "",
          currency: filter_currency,
          is_hq: false,
        }),
      ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({
      data,
      loaded: true,
      count,
    });
    loading(false);
  };
  Create = async () => {
    if (!this.state.broker_id.trim()) {
      alert("", "warning", "Warning", "Please select Broker");
      return;
    } else if (!this.state.ref_no.trim()) {
      alert("", "warning", "Warning", "Please input Ref No");
      return;
    } else if (!this.state.amount.trim()) {
      alert("", "warning", "Warning", "Please input Amount");
      return;
    }

    const {
      broker_id,
      customer_id,
      ref_no,
      amount,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
    } = this.state;
    let body = {
      broker_id,
      customer_id,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      ref_no,
      amount: Number(amount),
    };
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let result = await POST(`transactions/${params("type")}/create`, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  Update = async () => {
    if (!this.state.fee_type.trim()) {
      alert("", "warning", "Warning", "Please select Fee Rate Type");
      return;
    } else if (!this.state.fee_rate.trim()) {
      alert("", "warning", "Warning", "Please input Fee Rate");
      return;
    }
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      const { fee_type, fee_rate, is_vat, status, is_usdt } = this.state;
      let body = {
        fee_type,
        fee_rate: Number(fee_rate).toFixed(4),
        is_vat,
        status,
        is_usdt,
      };

      let result = await PUT(
        `transactions/${params("type")}/update/` + this.state.uid,
        body
      );
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  calDetail = async () => {
    const { fee_type, fee_rate, is_vat, amount, cost_gateway } = this.state;
    const _amount = Number(amount);
    const _fee =
      fee_type === "fixed"
        ? Number(fee_rate)
        : Number((_amount * (Number(fee_rate) / 100)).toFixed(4));
    const _vat = Number((_fee * 0.07).toFixed(4));
    const amountAfterFee = _amount - _fee;
    const amountNet = is_vat
      ? Number((amountAfterFee - _vat).toFixed(4))
      : Number(amountAfterFee.toFixed(4));

    this.setState({
      fee: _fee.toFixed(4),
      amount_net: (amountNet - Number(cost_gateway)).toFixed(4),
      vat: is_vat ? _vat.toFixed(4) : "00.00",
    });
  };
  Inquiry = async () => {
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the Inquiry?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      const { uid } = this.state;
      let body = { uid };
      let result = await GET(`transactions/inquiry`, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  render() {
    const {
      modal_detail,
      filter_status,
      filter_start_date,
      filter_end_date,
      filter_data_search,
      filter_process_type,
      filter_currency,
      data,
      loaded,
      count,
      type,
      ref_no,
      status,
      amount,
      created_at,
      fee,
      fee_rate,
      fee_type,
      vat,
      is_vat,
      amount_net,
      currency,
      remark,
      broker,
      customer,
      cost_gateway,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
<div>
              <div className="ar-eyebrow mb-1">Agent</div>
              <h2 className="ar-title mb-1">
                {params("type")?.charAt(0).toUpperCase() + params("type")?.slice(1)}{" "}
                Management
              </h2>
              <div className="ar-subtitle">
                Manage and monitor{" "}
                {params("type")?.charAt(0).toUpperCase() +
                  params("type")?.slice(1).toLocaleLowerCase()}{" "}
                transactions
              </div>
            </div>
            </div>
<div className="ar-toolbar ar-filter mt-3">
  <div className="ar-filter-head">
    <span className="ar-toolbar-label"><span className="icon me-2">{"\uf0b0"}</span>Filter</span>
    <span className="ar-toolbar-hint">Press Enter in the search box or click Search to apply</span>
  </div>
  <div className="ar-filter-row">
    <div className="ar-filter-field">
      <span className="ar-filter-label">Process Type</span>
              <Select
            className="form-control"
            placeholder="Process Type"
            options={[
              { value: "", label: "Process Type" },
              { value: "manual", label: "Manual" },
              { value: "auto", label: "Auto" },
            ]}
            value={filter_process_type}
            onChange={(v) => {
              this.setState({ filter_process_type: v });
            }}
            default={false}
          />
    </div>
    <div className="ar-filter-field">
      <span className="ar-filter-label">Status</span>
          <Select
            className="form-control"
            placeholder="Status"
            options={[
              { value: "", label: "Status" },
              { value: "pending", label: "Pending" },
              { value: "success", label: "Success" },
              { value: "mismatch", label: "MisMatch" },
              { value: "cancel", label: "Cancel" },
            ]}
            value={filter_status}
            onChange={(v) => {
              this.setState({ filter_status: v });
            }}
            default={false}
          />
    </div>
    <div className="ar-filter-field">
      <span className="ar-filter-label">Date Range</span>
                <DateRangePicker
                  className="form-control"
                  onChange={(e) => {
                    this.setState({
                      filter_start_date: e.start_date,
                      filter_end_date: e.end_date,
                    });
                  }}
                  value={{
                    start_date: filter_start_date,
                    end_date: filter_end_date,
                  }}
                  max={filter_end_date}
                />
    </div>
    <div className="ar-filter-field ar-filter-field-search">
      <span className="ar-filter-label">Search</span>
              <input
                type="text"
                className="form-control pr-input"
                placeholder="Refno, Customer..."
                onChange={(e) => {
                  this.setState({ filter_data_search: e.target.value });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_data_search}
              />
    </div>
    <div className="ar-toolbar-actions">
                <button
                  className="ar-btn-gold"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  <span className="icon me-2">{"\uf002"}</span>Search
                </button>
                <button
                  className="ar-btn-ghost"
                  onClick={() =>
                    this.setState(
                      {
                        filter_status: "",
                        filter_start_date: "",
                        filter_end_date: "",
                        filter_data_search: "",
                        filter_process_type: "",
                        filter_currency: "THB",
                      },
                      () => this.Get(1)
                    )
                  }
                >
                  Reset
                </button>
    </div>
  </div>
  <div className="ar-filter-foot">
                  {global.currency?.map((item) => (
                <button
                  className={`ar-pill ${
                    item.currency_code === filter_currency ? "active" : ""
                  }`}
                  onClick={() => {
                    this.setState({ filter_currency: item.currency_code });
                    setTimeout(() => {
                      this.Get(1);
                    }, 100);
                  }}
                >
                  {item.image}
                  <span className="ms-1">{item.currency_code}</span>
                </button>
              ))}
  </div>
</div>
            </div>
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{"\uf1ad"}</span>
                  {params("type")?.charAt(0).toUpperCase() + params("type")?.slice(1)}
                  <span className="pu-currency-tag">{filter_currency}</span>
                </div>
                <div className="ar-table-caption">Agent transactions</div>
              </div>
            </div>
            <div className="table-responsive" style={{ minHeight: 300 }}>
              <table className="table table-hover ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    <td className="text-nowrap">time</td>
                    <td className="text-nowrap">Ref No</td>
                    <td className="text-nowrap">Customer</td>
                    <td className="text-nowrap text-end">Amount</td>
                    <td className="text-nowrap text-end">Fee%</td>
                    <td className="text-nowrap text-end">Fee</td>
                    <td className="text-nowrap text-end">VAT</td>
                    <td className="text-nowrap text-end">Amount Net</td>
                    <td className="text-nowrap text-center">Process</td>
                    <td className="text-nowrap text-center wpx-100">Status</td>
                    <td className="text-center td-actions">Actions</td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={`array-${index}`}>
                      <td data-label="time" className="text-nowrap">
                        {format_date(item.created_at, "dd/mm/yy hh:mm", "en")}
                      </td>
                      <td data-label="Ref No" className="text-nowrap">
                        {item.ref_no}
                      </td>
                      <td data-label="Customer" className="text-nowrap">
                        {item.customer?.name_en || "-"}
                      </td>
                      <td
                        data-label="Amount"
                        className="text-nowrap text-end text-success"
                      >
                        {toFixed(item.amount, 2)}
                      </td>
                      <td data-label="Fee%" className="text-nowrap text-end">
                        {toFixed(item.fee_rate, 2)}%
                      </td>
                      <td data-label="Fee" className="text-nowrap text-end">
                        {toFixed(item.fee, 2)}
                      </td>
                      <td data-label="VAT" className="text-nowrap text-end">
                        {item.is_vat ? toFixed(item.vat, 2) : "0.00"}
                      </td>
                      <td
                        data-label="Amount Net"
                        className="text-nowrap text-end text-success"
                      >
                        {toFixed(item.amount_net, 2)}
                      </td>
                      <td
                        data-label="Process"
                        className="text-nowrap text-center"
                      >
                        {item.process_type === "manual"
                          ? Status("manual", "info")
                          : item.process_type === "auto"
                          ? Status("auto", "success")
                          : Status("-", "warning")}
                      </td>
                      <td
                        data-label="Status"
                        className="text-nowrap text-center"
                      >
                        {StatusTnx(item.status)}
                      </td>
                      <td data-label="Actions" className="text-center td-actions">
                        <Dropdown align="end">
                          <Dropdown.Toggle className="pu-action-toggle" id={`agent-dw-actions-${index}`}>Action</Dropdown.Toggle>
                          <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                            <Dropdown.Item
                              className="pu-action-item"
                              onClick={() => {
                                this.setState({
                                  ...item,
                                  modal_detail: true,
                                });
                              }}
                            >
                              <span className="icon">{"\uf06e"}</span>Detail
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                  {loaded && data?.length === 0 && (
                    <tr>
                      <td
                        colSpan={11}
                        className="text-center text-secondary py-4"
                      >
                        No data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_detail}
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={() => this.setState({ modal_detail: false })}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Transaction detail</div>
              <h5 className="fw-bold mb-0">
                Create Transaction{" "}
                {params("type")?.charAt(0).toUpperCase() +
                  params("type")?.slice(1)}
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section">
            <div className="pu-kv">
              <div className="pu-kv-label">Status</div>
              <div className="pu-kv-value">{StatusTnx(status)}</div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">Ref No.</div>
              <div className="pu-kv-value">{ref_no}</div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">Time</div>
              <div className="pu-kv-value">
                {format_date(created_at, "dd/mm/yyyy", "en")}
              </div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">Type</div>
              <div className="pu-kv-value">{type}</div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">Customer</div>
              <div className="pu-kv-value">{customer?.name_en || "-"}</div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">Broker</div>
              <div className="pu-kv-value">{broker?.name_en || "-"}</div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">Fee Rate Type</div>
              <div className="pu-kv-value">{fee_type}</div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">Fee Rate</div>
              <div className="pu-kv-value">
                {toFixed(fee_rate, 2)}{" "}
                {fee_type === "percentage" ? "%" : currency || "THB"}
              </div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">Amount</div>
              <div className="pu-kv-value">
                {toFixed(amount, 2)} {currency || "THB"}
              </div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">Fee Gateway</div>
              <div className="pu-kv-value">
                {toFixed(cost_gateway, 2)} {currency || "THB"}
              </div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">Fee</div>
              <div className="pu-kv-value">
                {toFixed(fee, 2)} {currency || "THB"}
              </div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">VAT Type</div>
              <div className="pu-kv-value">{is_vat ? "VAT" : "NO VAT"}</div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">VAT</div>
              <div className="pu-kv-value">
                {toFixed(vat, 2)} {currency || "THB"}
              </div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">Amount Net</div>
              <div className="pu-kv-value">
                {toFixed(amount_net, 2)} {currency || "THB"}
              </div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">Remark</div>
              <div className="pu-kv-value">{remark}</div>
            </div>
            <div className="pu-kv">
              <div className="pu-kv-label">Accountant Remark</div>
              <div className="pu-kv-value">{""}</div>
            </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
